import React, { Component } from 'react';
import { Modal, Button,Alert } from 'react-bootstrap';

/**
 * send props 'show={true }' to show the component
 * 'func' the delete function in the parent component
 * closeParentModal() to cahnge this.sate.show=false in parent function
 *  <ShowPopup show={true} func={this.deleteProfileImage}
 */

class ShowPopupArv extends Component {
   constructor(props){
       super(props);
       this.state={
           show:true
       }

       this.closeModel = this.closeModel.bind(this);
       this.deletefunc = this.deletefunc.bind(this);
   }
    componentWillMount(){
    }

    deletefunc(){
        /**to close model */
        this.setState({ show: false });
        /**function is called which is to be execute on ok */
        this.props.func(); 
    }
    
    closeModel(){
        /**to close modal */
        this.setState({show:false});
        this.props.closeParentModal();
    }

    render() {
        const {message} =this.props;
        return (
            <div>
                <Modal 
                show={this.state.show}
                onHide={this.closeModel}
                >
                    <Modal.Header closeButton className='theme-bg'>
                        <Modal.Title>
                       
                        </Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                    <Alert bsStyle="info">
                                  <strong>NOTE : </strong>
                                  <span>{message}</span>
                            {/* <span>This is total sq ft, includes above and below sq ft as well as unfinished and finished sq ft.</span>           */}
                        </Alert> 
                    </Modal.Body>

                    <Modal.Footer>
                        {/* <Button className='btn btn-default' onClick={this.closeModel}>Cancel</Button>
                        <Button className='btn red-mint' onClick={this.deletefunc} >Delete</Button> */}
                    </Modal.Footer>
                </Modal>
            </div>
            
        );
    }
}
export default ShowPopupArv;